import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Nosotros from "./components/Nosotros";
import Contact from "./components/Contact";
import Footer from "./components/Footer";


export default function App() {
  return (
    <div className="min-h-screen bg-bg">
      
      <Navbar />

      <section id="top" className="pt-30">
        <Hero />
      </section>

      {/* FEATURES FULL WIDTH */}
      <Features />

      {/* CONTENIDO NORMAL */}
      <main className="mx-auto max-w-6xl px-4">
        <section id="nosotros" className="scroll-mt-24 py-16">
          <Nosotros />
        </section>

        <section id="contact" className="scroll-mt-24 py-16">
          <Contact />
        </section>
      </main>

      <Footer />
    </div>
  );
}
